// extracted by mini-css-extract-plugin
export default {"amount":"DynamicInput_amount__V0Smw","amount_input":"DynamicInput_amount_input__el3lk"};